/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InterrogatoryQueryStatus {
    NotStarted = 0,
    Processing = 100,
    Complete = 200,
    Error = 300
}

export function InterrogatoryQueryStatusFromJSON(json: any): InterrogatoryQueryStatus {
    return InterrogatoryQueryStatusFromJSONTyped(json, false);
}

export function InterrogatoryQueryStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InterrogatoryQueryStatus {
    return json as InterrogatoryQueryStatus;
}

export function InterrogatoryQueryStatusToJSON(value?: InterrogatoryQueryStatus | null): any {
    return value as any;
}

